import { Lock } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

interface TierGateProps {
  /** Label for the locked feature */
  feature: string;
  /** Optional custom message */
  message?: string;
  /** Render as inline badge instead of card */
  inline?: boolean;
}

/**
 * Renders a locked-feature placeholder for tier-restricted content.
 * Shows the feature name with a lock icon and upgrade prompt.
 */
export function TierGate({ feature, message, inline }: TierGateProps) {
  const msg = message ?? "Upgrade to Tier 2 to unlock this feature.";

  if (inline) {
    return (
      <span className="inline-flex items-center gap-1.5 text-xs text-muted-foreground">
        <Lock className="h-3 w-3" />
        <span>{feature}</span>
      </span>
    );
  }

  return (
    <Card className="border-dashed border-muted-foreground/30 bg-muted/20">
      <CardContent className="flex items-center gap-3 py-6">
        <div className="rounded-full bg-muted p-2">
          <Lock className="h-5 w-5 text-muted-foreground" />
        </div>
        <div>
          <p className="text-sm font-medium text-muted-foreground">
            {feature} <span className="text-xs">🔒</span>
          </p>
          <p className="text-xs text-muted-foreground/70 mt-0.5">{msg}</p>
        </div>
      </CardContent>
    </Card>
  );
}
